var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "key-value-table uk-table uk-table-divider uk-table-justify"
  }, [_c('tbody', _vm._l((_vm.entries), function(entry) {
    return _c('tr', [_c('td', {
      staticClass: "key-value-table__key uk-table-shrink uk-text-right uk-text-bold",
      attrs: {
        "title": entry[_vm.namesFrom]
      }
    }, [_vm._v("\n        " + _vm._s(entry[_vm.namesFrom]) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "key-value-table__value"
    }, [_vm._t(entry[_vm.namesFrom], [(entry[_vm.valuesFrom]) ? _c('span', [_vm._v(_vm._s(entry[_vm.valuesFrom]))]) : _c('text-placeholder')], {
      name: "value",
      value: entry[_vm.valuesFrom]
    })], 2)])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b77a49e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/KeyValueTable.vue
// module id = 2079
// module chunks = 0